/** @jsx jsx */
import { jsx } from "theme-ui";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../sanityConfig";
import { getGatsbyImageData } from "gatsby-source-sanity";
import PortableTextComponent from "../serializers/portableTextComponents";
import { PortableText } from "@portabletext/react";
import Container from "../container";
import LinkResolve from "./linkResolve";

const HeroV2 = ({ value }) => {
  const mainImageData = getGatsbyImageData(
    value.image,
    { maxWidth: 500 },
    sanityConfig
  );
  return (
    <div
      id={value?.id?.current ? value?.id?.current : ""}
      sx={{
        background: value?.background == "white" ? "white" : "grayBG",
        padding: [
          "70px 0px 70px 0px",
          "70px 0px 70px 0px",
          value?.logos ? "75px 0px 75px 0px" : "145px 0px 145px 0px",
        ],
      }}
    >
      <Container>
        {value?.logos && (
          <div
            sx={{
              display: "flex",
              marginBottom: "40px",
              alignItems: "center",
              ".gatsby-image-wrapper-constrained": {
                display: "inline-block",
                verticalAlign: "top",
              },
              ".gatsby-image-wrapper": {
                position: "relative",
                overflow: "hidden",
                "> div": {
                  display: "none !important",
                },
              },
              img: {
                height: "auto",
                maxWidth: "100%",
                position: "relative",
                width: "100%",
                objectFit: "contain !important",
              },
              div: {
                maxWidth: "215px",
              },
              "div:nth-child(1)": {
                borderRight: "thin solid",
                borderColor: "primary",
                display: "flex",
                height: "72px",
                marginRight: "40px",
                paddingRight: "40px",
              },
            }}
          >
            {value.logos.map((item, index) => (
              <GatsbyImage
                key={index}
                image={getGatsbyImageData(
                  item,
                  { maxWidth: 1100 },
                  sanityConfig
                )}
              />
            ))}
          </div>
        )}
        <div
          sx={{
            display: "grid",
            gridColumnGap: ["0px", "0px", "50px"],
            gridTemplateColumns: ["100%", "100%", "53% 1fr"],
          }}
        >
          <h1
            sx={{
              fontSize: ["2.75rem", "3.5rem"],
              margin: "0px 0px 10px 0px",
              lineHeight: "3.4rem",
              maxWidth: ["100%", "100%", "600px"],
              gridColumn: "1",
              gridRow: "1",
            }}
          >
            {value.heading}
          </h1>
          <div
            className="hero-image-container"
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginBottom: ["30px", "30px", "0px"],
              marginTop: ["60px", "60px", "0px"],
              gridColumn: ["1", "1", "2"],
              gridRow: ["2", "2", "span 10"],
            }}
          >
            <GatsbyImage image={mainImageData} />
          </div>
          <div
            sx={{
              color: "textGray",
              fontSize: "body",
              lineHeight: "2.2rem",
              maxWidth: ["100%", "100%", "600px"],
              gridColumn: "1",
              gridRow: ["3", "3", "row / span 2"],
              ".cta": {
                lineHeight: "1.5",
                marginTop: "20px",
              },
              p: {
                margin: "10px 0px",
              },
            }}
            className="hero-copy-container"
          >
            <PortableText
              value={value.copy}
              components={PortableTextComponent}
            />
            {value.cta && (
              <div
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  a: {
                    variant: "buttons.primaryBlue",
                    marginTop: "15px",
                    display: "inline-block",
                  },
                }}
              >
                <LinkResolve
                  link={value.cta?.link}
                  children={value.cta?.label}
                  target="_blank"
                  ariaLabel={value.cta?.arialLabel}
                />
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeroV2;
